module.exports = __webpack_public_path__ + "img/intelligent-m2.bfa91a9b.png";